export default [
  {
    key: 'popularity',
    name: 'Popularité',
    info:
      'Spotify attribue un score de popularité à chaque chanson en fonction de sa fréquence de lecture. Les chansons écoutées récemment ont un poids plus important.',
    values: [
      { gen: 'gen_z', value: '76.14' },
      { gen: 'gen_y', value: '77.45' },
      { gen: 'gen_x', value: '75.61' },
      { gen: 'gen_boomer', value: '74.22' }
    ],
    songhigh: '6ocbgoVGwYJhOv1GgI9NsF',
    songlow: '0jAXSBY7bbgtl4oHjNSmB0',
    texthigh: 'Popularité haute',
    textlow: 'Popularité basse'
  },
  {
    key: 'valence',
    name: 'Gaieté',
    info: 'Les chansons avec un score haut sont plus joyeuses.',
    values: [
      { gen: 'gen_z', value: '0.481063' },
      { gen: 'gen_y', value: '0.488823' },
      { gen: 'gen_x', value: '0.48549' },
      { gen: 'gen_boomer', value: '0.525176' }
    ],
    songhigh: '1mqlc0vEP9mU1kZgTi6LIQ',
    songlow: '2RSHsoi04658QL5xgQVov3',
    texthigh: 'Gaieté haute',
    textlow: 'Gaieté basse'
  },
  {
    key: 'energy',
    name: 'Énergie',
    info:
      'Les chansons au rythme rapide ont un score plus haut dans cette catégorie.',
    values: [
      { gen: 'gen_z', value: '0.64611' },
      { gen: 'gen_y', value: '0.67979' },
      { gen: 'gen_x', value: '0.64815' },
      { gen: 'gen_boomer', value: '0.61494' }
    ],
    songhigh: '2zYzyRzz6pRmhPzyfMEC8s',
    songlow: '43zdsphuZLzwA9k4DJhU0I',
    texthigh: 'Énergie haute',
    textlow: 'Énergie basse'
  },
  {
    key: 'speechiness',
    name: 'Parlé ou chanté',
    info:
      'Ce score indique si une chanson est proche de la langue parlée. Le hip-hop atteint des valeurs élevées par rapport aux chansons chantées.',
    values: [
      { gen: 'gen_z', value: '0.140021' },
      { gen: 'gen_y', value: '0.105126' },
      { gen: 'gen_x', value: '0.085409' },
      { gen: 'gen_boomer', value: '0.068757' }
    ],
    songhigh: '0eKKoqxVuKTQAfzNXlCeCD',
    songlow: '0tgVpDi06FyKpA1z0VMD4v',
    texthigh: 'Plus parlé que chanté',
    textlow: 'Plus chanté que parlé'
  },
  {
    key: 'acousticness',
    name: 'Sons acoustiques',
    info:
      'Plus cette valeur est élevée, plus le morceau est influencé par les instruments acoustiques.',
    values: [
      { gen: 'gen_z', value: '0.233753' },
      { gen: 'gen_y', value: '0.194634' },
      { gen: 'gen_x', value: '0.220352' },
      { gen: 'gen_boomer', value: '0.268999' }
    ],
    songhigh: '4kflIGfjdZJW4ot2ioixTB',
    songlow: '6Pgkp4qUoTmJIPn7ReaGxL',
    texthigh: 'Partie acoustique haute',
    textlow: 'Partie acoustique basse'
  },
  {
    key: 'liveness',
    name: 'En live',
    info:
      'Plus cette valeur est élevée, plus une chanson contient des éléments de concert direct devant un public.',
    values: [
      { gen: 'gen_z', value: '0.152749' },
      { gen: 'gen_y', value: '0.159568' },
      { gen: 'gen_x', value: '0.170865' },
      { gen: 'gen_boomer', value: '0.189081' }
    ],
    songhigh: '1oNK2oXDXWGEJLFZCPC68b',
    songlow: '4w8niZpiMy6qz1mntFA5uM',
    texthigh: 'Proportion en live haute',
    textlow: 'Proportion en live basse'
  },
  {
    key: 'danceability',
    name: 'Dansabilité',
    info:
      'Plus ce score est élevé, plus une chanson est dansante. Il est basé sur le tempo, la stabilité du rythme et sa régularité.',
    values: [
      { gen: 'gen_z', value: '0.72118' },
      { gen: 'gen_y', value: '0.70667' },
      { gen: 'gen_x', value: '0.67092' },
      { gen: 'gen_boomer', value: '0.6398' }
    ],
    songhigh: '5vdp5UmvTsnMEMESIF2Ym7',
    songlow: '3TETmhGNWOcquUTtcr6RIR',
    texthigh: 'Dansabilité haute',
    textlow: 'Dansabilité basse'
  },
  {
    key: 'duration_ms',
    name: 'Durée de la chanson',
    values: [
      { gen: 'gen_z', value: '199376.9' },
      { gen: 'gen_y', value: '207583.1' },
      { gen: 'gen_x', value: '216130.3' },
      { gen: 'gen_boomer', value: '228427.7' }
    ],
    songhigh: '5CQ30WqJwcep0pYcV4AMNc',
    songlow: '4S8d14HvHb70ImctNgVzQQ',
    texthigh: 'Durée longue',
    textlow: 'Durée courte'
  }
]
